import { Usuario } from './usuario';

export class Empleado extends Usuario {
    idEmpleado: number;
    claveEmpleado: string;
    puesto: string;
    descripcion: string;
    fechaIngreso: Date;
    idSucursal: number;
    activo: boolean;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/empleado.ts